import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f3f3f3;
  min-height: 100vh;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;

  margin: 15px 0px;
  width: 90%;
  padding: 15px;

  background: #ffffff;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
  border-radius: 2px;

  font-size: 1rem;

  button {
    margin-top: 15px;
  }
  span + span {
    margin-top: 0px;
  }
  span {
    margin: 20px 0;
    div {
      width: 100%;
    }
    button {
      margin-top: 0px;
    }
  }
`;

// export const Question = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: space-between;

//   margin: 20px 0;

//   button {
//     margin: 0px;
//   }
// `;

export const Title = styled.h1`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  margin-top: 20px;
  margin-bottom: 0px;
`;
export const SubTitle = styled.h4`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  margin-top: 10px;
  margin-bottom: 20px;
`;

export const Select = styled('select')<{ error: boolean }>`
  border-radius: 5px;

  height: 45px;
  padding: 15px;

  border: none;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.13);
  background: #fcfcfc;
  color: rgba(0, 0, 0, 0.5);
  ${props => props.error && 'border: 1px solid #DF0A24;'}
`;

export const ErroAlert = styled.p`
  margin-top: 4px;
  color: #df0a24;
  font-size: 10px;
  min-height: 16px;
  margin-top: -20px;
`;

export const ShareButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  max-height: 45px;
  padding: clamp(10px, 3vh, 20px);

  background: #23ce6b;
  box-shadow: 0px 2px 9px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  color: #f6f8ff;
  font-weight: 700;
`;
